import React from 'react';
import PropTypes from 'prop-types';
import { getCustomPinSvg, svgToDataUri, getMarkerByColor } from './markers';

// Renders a pin marker as a non-executing <img>: an uploaded custom SVG as a data-URI, else the
// preset color marker asset. Used in the report's pin-option tables (which double as the legend).
function PinIcon({ metadata, className, style }) {
  const customSvg = getCustomPinSvg(metadata);
  const src = customSvg ? svgToDataUri(customSvg) : getMarkerByColor(metadata?.color);

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className={className}
      style={{ width: 16, height: 20, objectFit: 'contain', verticalAlign: 'middle', ...style }}
    />
  );
}

PinIcon.propTypes = {
  metadata: PropTypes.shape({
    color: PropTypes.string,
    pinSvg: PropTypes.string,
    pin_svg: PropTypes.string,
  }),
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

PinIcon.defaultProps = {
  metadata: undefined,
  className: undefined,
  style: undefined,
};

export default PinIcon;
